jQuery( document ).ready(function($) {

    $(function() {
        $('.product-category-menu').matchHeight();
    });
    
   
    
    
    

});
